import { cn } from "@/lib/utils";

export function CodeSolid({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn("size-3 shrink-0", className)}
    >
      <path d="M9 18 3 12 9 6" />
      <path d="M15 6 21 12 15 18" />
      <path d="M13 6 11 18" />
    </svg>
  );
}
